export default __webpack_public_path__ + "static/media/project-athlete.a3c90f54.png";